import "./Poscard.scss";
import { useEffect, useState } from "react";

function Poscard({startFlowers}) {
  return (
    <div className="letter-image" onClick={startFlowers}>
      <div className="animated-mail">
        <div className="back-fold"></div>
        <div className="letter">
          <div className="letter-border"></div>
          <div className="letter-title"></div>
          <div className="letter-context"></div>
          <br></br>
          Moltes felicitats Amor, Ja son 24!
          <br></br>
          Clica aqui T'❤
          <div className="letter-stamp">
            <div className="letter-stamp-inner"></div>
          </div>
        </div>
        <div className="top-fold"></div>
        <div className="body"></div>
        <div className="left-fold"></div>
      </div>
      <div className="shadow"></div>
    </div>
  );
}
export default Poscard;
